// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import { Typography } from '@mui/material';

// TODO: Import MUI icon

// TODO: Import context
import { Context } from '../Common/Context';
import { Text } from '../Common/Text';

// TODO: Import custom component
import Slide from './Slide_S1Admission.jpg';

import BoxSubPage from '../Common/BoxSubPage';

const TransferStudents = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component S1Admission Rendered');

    // TODO: Define useContext
    const context = React.useContext(Context);

    // TODO: Define variable

    // TODO: Define event

    // TODO: Return component
    return (
        <BoxSubPage
            id="S1Admission"
            image={Slide}
            title={Text.Top.Menu['ADM'].Title[context.language]}
            subtitles={Text.Top.Menu['ADM'].Subtitles}
        >
            <Typography sx={{ mb: 2 }} variant="body1">如家長有意為子女申請本校本學年中一至中四年級插班生學位，請留意以下安排：</Typography>
            <Typography variant="body1"><u>基本須知</u></Typography>
            <ul>
                <li>本校只接受中一至中四級之插班生申請</li>
                <li>申請人須在原校最近一學年所有科目成績達合格或以上，且操行成績達 B 級或以上。</li>
            </ul>
            <Typography variant="body1"><u>遞交方法</u></Typography>
            <ul>
                <li>申請人之家人或監護人於本校辦公時間內親臨本校一樓校務處領取及遞交有關資料(不接受傳真及電郵)。</li>
                <li><u>遞交申請所需文件如下：</u></li>
                <ul>
                    <li>插班生學位申請表（須附上申請人證件相）</li>
                    <li>出生證明文件副本</li>
                    <li>身份證明文件副本</li>
                    <li>香港入境處發出簽證／進入許可副本（如適用）</li>
                    <li>過往三學年之上、下學期成績表副本</li>
                    <li>相關的證書或獎狀副本／推薦信</li>
                </ul>
            </ul>
            <Typography variant="body1"><u>筆試及面試程序</u></Typography>
            <ul>
                <li>學校會因應各級的學位餘額、申請人的學業及操行表現而決定是否致電邀約申請人出席筆試，考核其中文、英文和數學的學習能力。</li>
                <li>如申請人筆試成績理想，會獲本校電話通知進行面試，著重考核申請人的溝通能力和了解申請人的各項潛能。</li>
                <li>在筆試和面試表現經收生委員會評選後，本校會以電話通知獲取錄之申請人。</li>
                <li>申請人及家人/監護人須於指定日期和時間到校註冊，逾期作放棄學位論。</li>
            </ul>
            <Typography variant="body1"><u>資料(私隱)條例聲明</u></Typography>
            <ul>
                <li>申請表格所收集的資料，將用以處理申請入讀本校事宜，學校亦可能會向教育局披露相關資料，如提供的資料不足，學校可能無法處理申請人之入學申請。</li>
                <li>所有資料一經遞交，概不發還。</li>
                <li>根據個人資料(私隱)條例規定，為確保各家長及申請人所提供的個人資料得到保障，本校會於評選後兩星期內將所有資料銷毀。</li>
            </ul>
            <Typography variant="body1"><u>辦公時間</u></Typography>
            <Typography variant="body1">星期一至五：上午9時至下午5時</Typography>
            <Typography variant="body1">星期六：上午9時至中午12時</Typography>
        </BoxSubPage>
    );
}
export default TransferStudents;